import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRestClient } from "@/lib/restClient";
import { exportComposition } from "./configurationApi";
import { exportFileName, type TransferKind } from "./configurationModel";
import { downloadTransfer } from "./dataTransferApi";

export interface ExportTarget {
  kind: TransferKind;
  id: string;
  slug: string;
}

/**
 * "Export as JSON" on one dashboard or template: the file holds the composition and
 * the names of the tenants and widgets it uses, so another platform can match them.
 * Each export is kept in the Data Transfer history like a full one.
 */
export function useExportComposition() {
  const api = useRestClient();
  const client = useQueryClient();
  return useMutation({
    mutationFn: async (target: ExportTarget) => {
      const result = await exportComposition(api, target.kind, target.id);
      downloadTransfer(result.configuration, exportFileName(target.slug));
      return result;
    },
    onSettled: () => void client.invalidateQueries({ queryKey: ["data-transfers"] }),
  });
}
